// extracted by mini-css-extract-plugin
export default {"progress":"styles_progress__tcIzX"};